'use strict';

var _ = require('lodash');
var TacticalFareDefinitionDataService = function TacticalFareDefinitionDataService(restangular) {
  var tacticalFareDefinitionEndPoint = restangular.one('configuration').one('hep');
  function getTacticalFareDefinitionData(attributes) {
    var searchCriteria = buildTacticalFareDefinitionSearchCriteria(attributes);
    return getTacticalFareDefinitionConfig(searchCriteria).then(transformTacticalFareDefinition);
  }
  function buildTacticalFareDefinitionSearchCriteria(attrbutes) {
    return ['carrier == ' + attrbutes.carrier, 'origin == ' + attrbutes.origin, 'destination == ' + attrbutes.destination, 'cabin == ' + attrbutes.cabin, 'originCountry == ' + attrbutes.originCountry, 'destinationCountry == ' + attrbutes.destinationCountry].join(';');
  }
  function getTacticalFareDefinitionConfig(filter) {
    var queryParams = {
      type: 'FOTacticalFareDefinition',
      filter: filter,
      pageLimit: -1
    };
    return tacticalFareDefinitionEndPoint.get(queryParams);
  }
  function transformTacticalFareDefinition(data) {
    var tacticalFareDefinitionProperties = _.get(data, ['hepList', 0, 'properties', 'tacticalFareDefinitionPropertiesList']);
    return getPrimaryGroupingRelatedEntries(tacticalFareDefinitionProperties);
  }
  function getPrimaryGroupingRelatedEntries(hepProperties) {
    return _.chain(hepProperties).filter({
      grouping: 'Primary'
    }).value();
  }
  return {
    getTacticalFareDefinitionData: getTacticalFareDefinitionData
  };
};
TacticalFareDefinitionDataService.$inject = ['Restangular'];
module.exports = TacticalFareDefinitionDataService;